(() => {
  const roots = document.querySelectorAll('[data-littleg-tool-result]');

  const text = (value) =>
    typeof value === 'string' ? value.trim().slice(0, 2000) : '';

  const sameOriginUrl = (value) => {
    if (typeof value !== 'string' || value.length > 2048 ||
        value.startsWith('//')) return null;
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin ||
          !['http:', 'https:'].includes(url.protocol) ||
          url.username || url.password) return null;
      return url.href;
    } catch {
      return null;
    }
  };

  const requestId = () =>
    window.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const sessionSubject = () => {
    try {
      const state = window.LittleGWebSession?.getState?.();
      return state?.status === 'authenticated' && typeof state.profile?.id === 'string'
        ? state.profile.id.trim() : '';
    } catch { return ''; }
  };
  const activeToolsTab = () => {
    try { return new URL(window.location.href).searchParams.get('tab') === 'tools'; }
    catch { return false; }
  };

  roots.forEach((root) => {
    const message = root.querySelector('[data-result-message]');
    const content = root.querySelector('[data-result-content]');
    const heading = root.querySelector('[data-result-heading]');
    const summary = root.querySelector('[data-result-summary]');
    const basisWrap = root.querySelector('[data-result-basis-wrap]');
    const basisList = root.querySelector('[data-result-basis]');
    const download = root.querySelector('[data-result-download]');
    const relatedWrap = root.querySelector('[data-result-related-wrap]');
    const relatedList = root.querySelector('[data-result-related]');
    const rerun = root.querySelector('[data-result-rerun]');

    let activeRequestId = '';
    let currentToolId = '';
    let currentResultId = '';
    let currentSubject = '';

    const clear = () => {
      content.hidden = true;
      rerun.disabled = true;
      heading.textContent = '';
      summary.textContent = '';
      basisList.replaceChildren();
      relatedList.replaceChildren();
      basisWrap.hidden = true;
      relatedWrap.hidden = true;
      download.hidden = true;
      download.removeAttribute('href');
    };

    const resetPrivate = () => {
      activeRequestId = '';
      currentToolId = '';
      currentResultId = '';
      clear();
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      message.textContent = '尚未載入結果。';
    };
    const sessionAuthorized = () => {
      const panel = root.closest('[data-my-tools-private]');
      return Boolean(sessionSubject() && activeToolsTab() && panel && !panel.hidden);
    };
    const syncPrivateSession = () => {
      const next = sessionSubject();
      if (!next || next !== currentSubject || !activeToolsTab()) {
        currentSubject = next;
        resetPrivate();
      }
    };

    const requestResult = () => {
      if (!sessionAuthorized() || currentSubject !== sessionSubject()) {
        resetPrivate();
        return;
      }
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      clear();
      activeRequestId = requestId();
      message.textContent = '正在安全載入結果…';
      root.dispatchEvent(new CustomEvent('littleg:tool-result-request', {
        bubbles: true,
        detail: {
          requestId: activeRequestId,
          toolId: currentToolId,
          resultId: currentResultId
        }
      }));
    };

    document.addEventListener('littleg:tool-result-open', (event) => {
      if (!sessionAuthorized()) return;
      const nextSubject = sessionSubject();
      if (nextSubject !== currentSubject) {
        currentSubject = nextSubject;
        resetPrivate();
      }
      const toolId = text(event.detail?.toolId);
      const resultId = text(event.detail?.resultId);
      if (!toolId || !resultId) return;
      currentToolId = toolId;
      currentResultId = resultId;
      requestResult();
    });

    document.addEventListener('littleg:tool-result-response', (event) => {
      if (!sessionAuthorized() || currentSubject !== sessionSubject()) {
        resetPrivate();
        return;
      }
      const data = event.detail;
      if (!data || data.requestId !== activeRequestId ||
          data.toolId !== currentToolId ||
          data.resultId !== currentResultId) return;

      clear();
      if (data.authorized !== true) {
        message.textContent = text(data.message) ||
          '無法讀取此結果。請確認登入及存取權限。';
        return;
      }

      heading.textContent = text(data.title) || '分析結果';
      summary.textContent = text(data.summary);

      if (Array.isArray(data.basis)) {
        data.basis.slice(0, 20).forEach((item) => {
          const value = text(item);
          if (!value) return;
          const li = document.createElement('li');
          li.textContent = value;
          basisList.append(li);
        });
      }
      basisWrap.hidden = !basisList.childElementCount;

      const downloadUrl = sameOriginUrl(data.downloadUrl);
      if (downloadUrl) {
        download.href = downloadUrl;
        download.hidden = false;
      }

      if (Array.isArray(data.relatedTools)) {
        data.relatedTools.slice(0, 12).forEach((item) => {
          const url = sameOriginUrl(item?.url);
          const label = text(item?.title);
          if (!url || !label) return;
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = url;
          link.textContent = label;
          li.append(link);
          relatedList.append(li);
        });
      }
      relatedWrap.hidden = !relatedList.childElementCount;

      content.hidden = false;
      rerun.disabled = false;
      message.textContent = '結果已載入。';
    });

    rerun.addEventListener('click', () => {
      if (!currentToolId || !sessionAuthorized() || currentSubject !== sessionSubject()) return;
      clear();
      message.textContent = '請重新核對權益與報價後再執行。';
      root.dispatchEvent(new CustomEvent('littleg:tool-selected', {
        bubbles: true,
        detail: { toolId: currentToolId }
      }));
    });
    document.addEventListener('littleg:web-session-change', syncPrivateSession);
    window.addEventListener('pageshow', syncPrivateSession);
    window.addEventListener('popstate', syncPrivateSession);
    syncPrivateSession();
  });
})();
